<template>
  <div
    class="profile-badge"
    :class="[`profile-${profile}`, (isCurrent?'py-2 px-3 font-weight-bold':''), (badgeWhite?'badge-white':'')]"
    @click="$emit('clicked')"
  >
    <i
      v-if="isCurrent"
      class="fa fa-check"
    />
    <ProfileTypeIcon
      v-else
      :profile="profile"
      class="profile-badge-icon"
    />
    {{ profileName }}
  </div>
</template>
<script>
import {getProfileName} from "@/repositories/Utils";
import ProfileTypeIcon from "@/components/ProfileTypeIcon.vue";

export default {
  name: 'ProfileTypeBadge',
  components: {ProfileTypeIcon},
  props: {
    profile: {
      type: String,
      default: 'PROCUREMENT'
    },
    badgeWhite: {
      type: Boolean,
      default: false
    },
    isCurrent: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    profileName() {
      return getProfileName(this.profile, this.$i18n);
    }
  }
}
</script>

<style lang="scss">

@import "@/assets/scss/scc_colors.scss";

.profile-badge {
  display: inline-block;
  border-radius: 6px;
  padding: 4px  10px 4px 4px;
  font-size: 13px;
  line-height: 20px;
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
  white-space: nowrap;

  &.badge-white{
    .profile-badge-icon{
      opacity: 0.5;
    }
  }

  .profile-badge-icon{
    margin-right: 5px;
    width: 19px;
    height: 19px;
  }

  &.profile-PROCUREMENT:not(.badge-white) {
    background: rgba($profile-procurement, 0.1);
    color: $profile-procurement;
  }

  &.profile-SUPPLIER:not(.badge-white) {
    background: rgba($profile-supplier, 0.2);
    color: $profile-supplier;
  }

  &.profile-LOGISTIC:not(.badge-white) {
    background: rgba($profile-logistic, 0.2);
    color: $profile-logistic;
  }

  &.profile-TRUCK:not(.badge-white) {
    background: rgba($profile-truck, 0.2);
    color: $profile-truck;
  }



}

</style>
